export const cookies = {
  get(name, clean) {
    const cookies = document.cookie.split(';');
    const cookieName = `${name}=`;
    let value = '';

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(cookieName) === 0) {
        value = cookie.substring(cookieName.length, cookie.length);
        break;
      }
    }

    if (clean === true) {
      remove(name); // todo undefined method
    }
    return value;
  },
  remove() {
    Array.from(arguments).forEach(
      (cookieName) =>
        (document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;`),
    );
  },
  set(name, value, exdays = 14, domain) {
    const date = new Date();
    if (exdays <= 60) {
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    } else {
      date.setTime(new Date(exdays * 1000));
    }
    const expires = date.toUTCString();
    if (domain) {
      document.cookie = `${name}=${value};expires=${expires};domain=${domain};path=/;`;
    } else {
      document.cookie = `${name}=${value};expires=${expires};path=/;`;
    }
  },
};
